// src/App.jsx
import React, { useEffect } from 'react';
import { Routes, Route, useNavigate,useLocation, matchPath } from 'react-router-dom';
//import Signup from './pages/Signup/Signup';
import PrivateRoute from './components/Auth/PrivateRoute';
import OAuthCallback from './pages/Auth/OAuthCallback';
//import { useAuth } from './context/AuthContext';

import {NotFoundPage,InternalServerErrorPage,ForbiddenPage,UnauthorizedPage} from './pages/Utility/error_pages';
import AdminLanding from './pages/Admin/AdminLanding';

import { KitchenSinkPage } from './components/dev/KitchenSinkPage';
import { Toaster } from './components/ui/toaster';

import { Header } from './components/Header';
import { Footer } from "./components/Footer";
import { TooltipProvider } from './components/ui/tooltip';
import GoogleSignInPage from './pages/Home/GoogleSignInPage';

const APP_TITLE_SUFFIX = 'Selyst Admin';

const APP_PAGE_TITLES = [
  { path: '/', title: 'Sign In' },
  { path: '/auth/callback', title: 'Signing In' },
  { path: '/kitchen-sink', title: 'Kitchen Sink' },
  { path: '/404', title: 'Page Not Found' },
  { path: '/500', title: 'Internal Server Error' },
  { path: '/403', title: 'Forbidden' },
  { path: '/401', title: 'Unauthorized' },
];

const getAppPageTitle = (pathname) => {
  if (pathname.startsWith('/admin')) {
    return null;
  }

  const matchedRoute = APP_PAGE_TITLES.find(({ path }) =>
    matchPath({ path, end: true }, pathname)
  );

  return matchedRoute?.title || 'Page Not Found';
};

function App() {
  
  //const {  logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pageTitle = getAppPageTitle(location.pathname);

    if (pageTitle) {
      document.title = `${pageTitle} | ${APP_TITLE_SUFFIX}`;
    }
  }, [location.pathname]);

  useEffect(() => {
      console.log(
        "APP.JS Redirect Check: Path=",
        location.pathname,
        "Flag=",
        localStorage.getItem("selyst_google_redirect")
      );

    // Check if the current path is '/' and if a social login redirect flag is present
    if (
      location.pathname === '/' &&
      localStorage.getItem('selyst_google_redirect') === 'true'
    ) {
      // Remove the flag to prevent repeated redirects
          console.log(
            "APP.JS: Google redirect condition MET. Navigating to /auth/callback"
          );

      localStorage.removeItem('selyst_google_redirect');
      // Redirect to the authentication callback route
      navigate('/auth/callback');
    }
  }, [location, navigate]);

  
  useEffect(() => {
    // Capture entry page URL if not already set in this session
    if (!sessionStorage.getItem("appEntryPageUrl")) {
      sessionStorage.setItem("appEntryPageUrl", window.location.href);
    }
  }, []); 

  /*
  const handleLogout = () => {
    logout(() => navigate('/'));
  }*/

  useEffect(() => {
    
    const urlParams = new URLSearchParams(window.location.search);
    const allowedPrefixes = ['utm_', 'gclid', 'fbclid'];
  
    const currentTracking = {};
    for (const [key, value] of urlParams.entries()) {
      if (allowedPrefixes.some(prefix => key.startsWith(prefix)) && value) {
        currentTracking[key] = value;
      }
    }
  
    if (Object.keys(currentTracking).length > 0) {
      const existing = JSON.parse(localStorage.getItem('selyst_tracking_params') || '{}');
  
      if (!existing.first_touch) {
        existing.first_touch = { ...currentTracking, _createdAt: Date.now() };
      }
  
      existing.last_touch = { ...currentTracking, _createdAt: Date.now() };
  
      localStorage.setItem('selyst_tracking_params', JSON.stringify(existing));
    }
  }, []);
  /*
  useEffect(() => {
    // Auto-redirect to dashboard if token/user exists
    //const token = localStorage.getItem('selyst_token');
    if (user && window.location.pathname === '/') {
      navigate('/SellerDashboard');
    }
  }, []); */
  /*
  console.log("user:", user);
  console.log("token:", token);
  console.log("localStorage:", localStorage.getItem('selyst_token'));*/



  //if (loading) return <div>Loading...</div>;

  return (
    <>
      <TooltipProvider>

      <Header />
      <div className="pt-24">
        <Routes>
          {/* Pass loading state down to routes/components that need it */}
          
          <Route path="/" element={<GoogleSignInPage />} />
          <Route path="/auth/callback" element={<OAuthCallback />} />
          {/* Admin Routes */}
          <Route path="/admin/*" element={<PrivateRoute><AdminLanding /></PrivateRoute>} />
          {/* Public Routes */}
          <Route path="/kitchen-sink" element={<KitchenSinkPage />} />

          {/*Error Pages*/}
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="/500" element={<InternalServerErrorPage />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="/401" element={<UnauthorizedPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
      {/*<Footer />*/}
      <Toaster />
      
      </TooltipProvider>
    </>
  );
}

export default App;
